export function AuditNavigation() {
  return <section className="mb-5 border-b pb-4">
    <div><h1 className="text-2xl font-semibold">Auditoria</h1><p className="mt-1 text-sm text-muted-foreground">Auditoria cadastral das unidades.</p></div>
  </section>;
}
